import gql from 'graphql-tag'

export const dataRegionsAppeal = gql`
  query listsRegionsAppeal {
    regions: elements(
      where: { iblock: { code: { equals: "appealRegions" } } }
    ) {
      name
      propertyValues {
        property {
          code
        }
        value
      }
    }
  }
`
